<div class="flex center gap margin-bottom m-wrap">
  @if (icon) {
    <div class="page-icon flex center justify-center radius bg-lightest-blue primary-dark">
      <i class="{{ icon }}"></i>
    </div>
  }
  <div class="flex-1 flex column">
    <h4 class="page-title uppercase primary-dark">{{ title }}</h4>
    @if (subtitle) {
      <span class="grey">{{ subtitle }}</span>
    }
  </div>
  <ng-content></ng-content>
</div>
